/**
 * Specifies the types of customer notes.
 */
export enum CustomerNoteTypeModel {
	General = 1,
	FileProcessing = 2,
	Duplicates = 3,
	Submission = 4,
	FileManagement = 5
}
